import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    CircularProgress,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { SubmitButton } from "components/buttons";
import { StyledTableRow } from "helpers/CustomMenu";
import { Delete } from "@mui/icons-material";
import AddModal from "./AddModal";

const CreateAction = (props) => {
    const {
        //     start,
        //     ranks,
        //     category,
        //     setCategory,
        settings,
        loggedUser,
        //     end,
        //     setStart,
        //     setEnd,
        //     name,
        //     setName,
        //     type,
        //     setType,
        //     venue,
        //     setVenue,
        //     room,
        //     setRoom,
        //     rooms,
        //     agenda,
        //     setAgenda,
        //     setFiles,
        //     removeUser,
        //     reminder,
        //     ExportFormat,
        //     onSelectUser,
        //     onSelectRole,
        //     setReminder,
        onSubmit,
        //     GetUsersByStructure,
        GetEmployees,
        //     users,
        //     structure,
        //     setSearchStructure,
        //     SearchStructure,
        //     searchStructure,
        //     loggedUser,
        //     selectedUsers,
        //     GetAllChildren,
        //     GetSameLevelStructure,
        //     GetAllStructure,
        //     removeRole,
        loading,
        //     validationMessage,
        //     field,
        errorMessage,
        //     setField,
        //     onSubmitDraft,
        //     createRoom,
        //     selectedRoles,
        setLoading,
        //     projects,
        //     setProject,
        //     project,
        //     GetAllResources,
        systemSettings,
        resources
    } = props;

    const [select, setSelect] = useState(false);

    const [confirm, setConfirm] = useState(false);
    const [listOfAction, setListOfAction] = useState([]);
    const [type, setType] = useState("");
    const [info, setInfo] = useState({})
    let history = useHistory();
    return (
        <div>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb flex items-center">
                    <li className="breadcrumb-item pageTitle">
                        <Link to="/admin/meeting" className="text-white text-decoration-none">
                            Action  /
                        </Link>
                    </li>
                    <li className="breadcrumb-item active pageTitle ml-1" aria-current="page">
                        New
                    </li>
                </ol>
            </nav>
            <div>
                <AddModal setType={setType}
                    setInfo={setInfo}
                    resources={resources}
                    GetEmployees={GetEmployees}
                    info={info}
                    type={type}
                    settings={settings}
                    setListOfAction={setListOfAction}
                    listOfAction={listOfAction}
                    setSelect={setSelect}
                          loggedUser={loggedUser}
                    select={select}
                    loading={loading} 
                    systemSettings={systemSettings}
                    />

                <form onSubmit={(e) => {
                    e.preventDefault();
                    setConfirm(true)

                }}>
                    <Card className="mt-4">
                        <CardHeader
                            title={"Create New Action"}
                            titleTypographyProps={{ variant: "h6" }}
                            action={
                                <div>
                                    <span className="fs-6 text-red-500">{errorMessage}</span>
                                    <Button variant="outlined" onClick={() => setSelect(true)}>Add New</Button>
                                </div>
                            } />
                        <CardContent>

                            {/* list of actions */}
                            <TableContainer>
                                <Table size={"small"}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>#</TableCell>
                                            <TableCell>Name</TableCell>
                                            <TableCell>Start date</TableCell>
                                            <TableCell>End date</TableCell>
                                            <TableCell>Description</TableCell>
                                            <TableCell>Responsible</TableCell>
                                            <TableCell>Report To</TableCell>
                                            <TableCell>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {listOfAction?.map((item, index) => (
                                            <StyledTableRow>
                                                <TableCell>#{index + 1}</TableCell>
                                                <TableCell>{item?.name}</TableCell>
                                                <TableCell>{item?.startDate}</TableCell>
                                                <TableCell>{item?.endDate}</TableCell>
                                                <TableCell><div dangerouslySetInnerHTML={{ __html: item?.description }} /></TableCell>
                                                <TableCell>{item?.responsibleName}</TableCell>
                                                <TableCell>{item?.reportName}</TableCell>
                                                <TableCell>
                                                    <IconButton
                                                        color={"error"}
                                                        onClick={() => {
                                                            listOfAction.splice(index, 1);
                                                            setListOfAction([...listOfAction]);
                                                        }}
                                                    >
                                                        <Delete />
                                                    </IconButton>
                                                </TableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>
                        <CardActions className={"float-end"}>
                            <Button
                                // color={"error"}
                                size="small"
                                variant="contained"
                                onClick={() => history.goBack()}>
                                Go Back
                            </Button>
                            {loading ? (
                                <CircularProgress />
                            ) : (
                                listOfAction.length ?
                                    <SubmitButton
                                        name="Confirm"
                                        title={"Click Yes to submit?"}
                                        handleAction={() => {
                                            setLoading(true);
                                            return onSubmit(listOfAction);
                                        }}
                                        confirm={confirm}
                                        setConfirm={setConfirm}
                                    />
                                    : null
                            )}
                        </CardActions>
                    </Card>
                </form>
            </div>
        </div>
    );
};
export default CreateAction;
